import axios from 'axios'

const remoteHostname = process.env.VUE_APP_DOMAIN_REMOTE.split(':')[0];
const isRemote = window.location.hostname === remoteHostname;
const baseURL = isRemote
    ? (window.location.protocol === 'https:' ? window.location.origin : process.env.VUE_APP_API_ENDPOINT_REMOTE)
    : process.env.VUE_APP_API_ENDPOINT;

const api = axios.create({
    baseURL,
    withCredentials: true,
});

export function resolveApiUrl(path) {
    if (!path || /^https?:\/\//i.test(path)) return path;

    return baseURL.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
}

export default api
